// =============================================================================
// Chart export — snapshot a rendered chart node to a PNG and download it.
//
// Captures the DOM exactly as shown (title, chart, legend, note) via html-to-image,
// so the saved image always matches the screen — no bespoke canvas re-drawing.
// =============================================================================
import { toPng } from 'html-to-image'

// Turn a title into a safe-ish filename stem.
function slugify(title: string): string {
  return (title || 'chart').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'chart'
}

// Snapshot `node` to a PNG (2× for crispness, white background) and trigger a download.
export async function downloadChartPng(node: HTMLElement, title: string): Promise<void> {
  try {
    const dataUrl = await toPng(node, { pixelRatio: 2, backgroundColor: '#ffffff' })
    const a = document.createElement('a')
    a.href = dataUrl
    a.download = `${slugify(title)}-${new Date().toISOString().slice(0, 10)}.png`
    a.click()
  } catch (e) {
    console.warn('Save PNG failed:', e)
  }
}
